import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {DescriptionHeaderViewModel} from "./description-header.view-model";
import {CompetitionViewModel} from "../../../../domain/common/competition/models/competition-view-model";
import {APP_REMOTE_CONFIG} from "../../../app/app-remote-config";
import {CompetitionLinkModel} from "../../../../containers/competition-container/models/competition.link-model";

export class DescriptionHeaderCompetitionViewModel extends DescriptionHeaderViewModel {
  get id(): Number {
    return this.entity.id
  }

  get color(): String {
    return this.entity.color
  }

  get textureId(): Number {
    return this.entity.id
  }

  get objectType(): EntityViewModel {
    return CompetitionViewModel.name;
  }

  get popularityRank(): String {
    return this.entity.popularityRank;
  }

  get extraIds(): String {
    return null;
  }

  get useLink(): Boolean {
    return true;
  }

  get linkModel(): CompetitionLinkModel {
    let linkModel: CompetitionLinkModel = null;
    if(this.useLink) {
      linkModel = new CompetitionLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    }
    return linkModel;
  }

  get shouldRenderPopularityRank(): Boolean {
    const minFollowers: Number = this.config.getValue(APP_REMOTE_CONFIG.MINIMUM_FOLLOWING_TO_DISPLAY);
    const shouldRenderPopularityRank: Boolean = this.popularityRank && this.popularityRank >= minFollowers;

    return shouldRenderPopularityRank
  }
}